module.exports = __webpack_public_path__ + "static/media/meta.c2e10563.png";